export default async function ({ app }) {
    if (app.$auth.user) {
        app.store.dispatch("navigation/updateUserType", app.$auth.user)
    }
}
